import React, { PropsWithChildren } from "react";
import { SimpleDialog } from "../../dialog/simple-dialog";

import "./photo-source-dialog.css";

export const PhotoSourceDialog = ({
	children,
	title,
	numberOfEmptyPhotoZonesLabel,
	open,
	onClose,
}: PropsWithChildren<{
	title: string;
	numberOfEmptyPhotoZonesLabel: string;
	open: boolean;
	onClose(): void;
}>) => (
	<SimpleDialog
		className="photo-source-dialog"
		isOpen={open}
		onScrimClick={() => onClose()}
		fullScreen
		onCloseIcon={() => onClose()}
	>
		<div className="photo-source-dialog__info">{numberOfEmptyPhotoZonesLabel}</div>
		<div className="photo-source-dialog__title">{title}</div>
		<div className="photo-source-dialog__sources">{children}</div>
	</SimpleDialog>
);
PhotoSourceDialog.displayName = "PhotoSourceDialog";
